import { render } from "./AddCommandeFournisseurPage.vue?vue&type=template&id=adf1e636&ts=true"
import script from "./AddCommandeFournisseurPage.vue?vue&type=script&lang=ts"
export * from "./AddCommandeFournisseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__